'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jcampconverter = require('jcampconverter');
var __ = require('..');
var xyParser = require('xy-parser');

/**
 * Create an object of Chromatogram
 * @return {object}
 */
function toJSON() {
  return {
    wavelength: this.wavelength,
    transmittance: this.transmittance
  };
}

/**
 * Class allowing manipulate one IR spectrum
 * @class IRSpectrum
 * @param {object} [json={}] - object containing a spectrum
 * @param {Array} [json.wavelength=[]] - wavelength
 * @param {Array} [json.y=[]] - y values
 * @param {integer} [json.kind=IRSpectrum.TRANSMITTANCE] - either IRSpectrum.ABSORBANCE or IRSpectrum.TRANSMITTANCE
 */
class IRSpectrum {
  constructor(json = {}) {
    this.wavelength = json.wavelength || [];
    this.absorbance = json.absorbance || [];
    this.transmittance = json.transmittance || [];
  }

  getAbsorbance() {
    if (this.absorbance.length > 0) {
      return { x: this.wavelength, y: this.absorbance };
    } else {
      if (this.transmittance.length > 0) {
        return {
          x: this.wavelength,
          y: this.transmittance.map((transmittance) => -Math.log10(transmittance))
        };
      } else {
        return { x: [], y: [] };
      }
    }
  }

  getTransmittance() {
    if (this.transmittance.length > 0) {
      return { x: this.wavelength, y: this.transmittance };
    } else {
      if (this.absorbance.length > 0) {
        return {
          x: this.wavelength,
          y: this.absorbance.map((absorbance) => 10 ** -absorbance)
        };
      } else {
        return { x: [], y: [] };
      }
    }
  }

  getPercentTransmittance() {
    let data = this.getTransmittance();
    return {
      x: data.x,
      y: data.y.map((transmittance) => transmittance * 100)
    };
  }
}

const ABSORBANCE = 1;
const TRANSMITTANCE = 2;

function getKind(kind = '') {
  if (typeof kind === 'number') {
    if (kind < 1 || kind > 2) {
      throw new Error('kind should either be 1 or 2');
    }
    return kind;
  }
  if (kind.match(/abs/i)) {
    return ABSORBANCE;
  }
  return TRANSMITTANCE;
}

IRSpectrum.prototype.toJSON = toJSON;

/**
 * Creates a new Chromatogram element based in a JCAMP string
 * @param {string} jcamp - String containing the JCAMP data
 * @return {IRSpectrum} - New class element with the given data
 */
function fromJcamp(jcamp) {
  const data = jcampconverter.convert(jcamp, { xy: true });
  let spectrum = data.spectra[0].data[0];
  if (__.getKind(data.spectra[0].yUnit) === __.TRANSMITTANCE) {
    return new __.IRSpectrum({
      wavelength: spectrum.x,
      transmittance: spectrum.y,
      absorbance: []
    });
  } else {
    return new __.IRSpectrum({
      wavelength: spectrum.x,
      transmittance: [],
      absorbance: spectrum.y
    });
  }
}

/**
 * Creates a new Chromatogram element based in a Txt string
 * @param {string} text - String containing the data as CSV or TSV
 * @param {object} [options] - Options object for the parser
 * @param {string} [options.kind] - Absorbance or Transmisstance
 * @return {IRSpectrum} - New class element with the given data
 */
function fromText(text, options = {}) {
  options = Object.assign({}, options, { arrayType: 'xxyy' });
  const data = xyParser.parseXY(text, options);
  if (getKind(options.kind) === TRANSMITTANCE) {
    return new IRSpectrum({
      wavelength: data[0],
      transmittance: data[1],
      absorbance: []
    });
  } else {
    return new IRSpectrum({
      wavelength: data[0],
      transmisttance: [],
      absorbance: data[1]
    });
  }
}

exports.ABSORBANCE = ABSORBANCE;
exports.IRSpectrum = IRSpectrum;
exports.TRANSMITTANCE = TRANSMITTANCE;
exports.fromJcamp = fromJcamp;
exports.fromText = fromText;
exports.getKind = getKind;
